import React from 'react'
import { Container } from './styles'

const ErrorBox = ({ error }) => {
  return error && (
   <Container>
     {error}
   </Container>
  )
}

export default ErrorBox
